import { render } from "./FilterCategory.vue?vue&type=template&id=0b8b067e"
import script from "./FilterCategory.vue?vue&type=script&lang=js"
export * from "./FilterCategory.vue?vue&type=script&lang=js"
script.render = render

export default script